<template>
    <div class="">
        <nav style="width:100%">
            <div class="block">
                <el-carousel :height="clientHeight">
                    <el-carousel-item v-for="item in bannerList" :key="item.bannerIndex">
                        <a href="#">
                            <!-- <div  @click="Jump(item.path)" class="banner" alt="" :style="{background: 'url(' + item.url + ')'}"></div> -->
                            <img @click="Jump(item.path)" class="banner" :src="item.url" alt="">
                        </a>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </nav>

        <div class="content">
            <h2>橙蟹为企业提供定制化的解决产品</h2>
            <div class="product">
                <div class="single" v-for="(list,i) in productList" :key="i">
                    <h3>{{list.typeName}}</h3>
                    <img :src="list.remark" alt="">
                    <p style="padding: 0 10%;height: 50px;">{{list.typeDesc}}</p>
                    <!-- <p>{{list.contentB}}</p> -->
                    <div v-if="list.id != 8" class="view" @click="jumpProduct(list.companyProductTypeId,list.typeCode)">
                        查看详情
                    </div>
                    <div v-else class="view" style="opacity: 0">
                        查看详情
                    </div>
                </div>
            </div>

            <h2>橙蟹提供响应企业主需求的财税解决方案</h2>
            <div class="tabs">
                <el-row class="tab-t">
                    <el-col :span="4">
                        <div style="height:1px;"></div>
                    </el-col>
                    <el-col :span="8">
                        <div>企业问题</div>
                    </el-col>
                    <el-col :span="12">
                        <div>财税解决方案</div>
                    </el-col>
                </el-row>
                <div class="tabs-container clearfix">
                    <ul class="tab-l">
                        <!-- <li v-for="(item,i) in solveList" :key="item.companyCaseId" @click="changeIndex(i)" :class="{active:(i === indexs)}">{{item.title}}</li> -->
                        <li class="tab-line" v-for="(item,i) in solveList" @mouseover="toggleShow(i)" :class="{active:(i === indexs)}" :key="item.companyCaseId">
                            <p>{{item.title}}</p>
                        </li>
                    </ul>
                    <div class="tab-slider"></div>
                    <div class="tab-r" v-for="(item,i) in solveList" :key="item.companyCaseId" v-if="i === indexs" @click="JumpServiceDetail(item.customerServiceId)">
                        <a class="jiejue"><img class="solveImg" :src="url+item.caseImg" alt=""></a>
                    </div>
                </div>
                <!-- <div>
                <el-tabs type="border-card" tabPosition="left">
                    <el-tab-pane v-for="item in solveList" :key="item.companyCaseId" :label="item.title">
                        <a class="jiejue"><img class="solveImg" :src="'http://47.98.146.185/uploads'+item.caseImg" alt=""></a>
                    </el-tab-pane>
                </el-tabs>
            </div> -->
            </div>

            <h2>顾问招募</h2>
            <div class="solicit" @click="Jump('/advisersRecruited')">
                <p>
                    互联智能，推动劳力服务向知识服务转移，专业人员迎来了自由流动创作的时代。<br>
                    用户得不到响应时代变化的价值服务，从业者人员收入和地位得不到提升。橙蟹为之而生。
                </p>
                <div>
                    <img src="../assets/img/home－image－3.png" alt="">
                </div>
            </div>

            <h2>小工具</h2>
            <div class="tool">
                <div @click="Jump('/business')">
                    <h3>橙蟹业务系统平台</h3>
                    <p>六大管理模块；三大核心功能；实时查看管理</p>
                </div>
                <!-- <div @click="Jump('/apply')">
                    <h3>橙蟹报销软件</h3>
                    <p>将各类支出乱报销化繁为简，一键管理企业支出</p>
                </div> -->
            </div>

            <h2>企业资讯<a class="more" @click="Jump('/about/qyzx')">查看更多></a></h2>
            <div class="information">
                <el-carousel>
                    <el-carousel-item v-for="item in informationList" :key="item.companyNewsId">
                        <div class="info-left fl" @click="Jump('/companyNewsDetail/' + item.companyNewsId +'/1')">
                            <img :src="url+item.companyNewsImg" alt="">
                        </div>
                        <div class="info-right" @click="Jump('/companyNewsDetail/' + item.companyNewsId + '/1')">
                            <h4>{{item.title}}</h4>
                            <p>{{item.description}}</p>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { companyCase, companyNews, getProductTypeList } from '../api/api.js'
export default {
  name: 'homePage',
  created () {
    companyCase().then((res) => {
      for (let i = 0; i < res.data.data.list.length; i++) {
        if (this.solveList.length < 5 && res.data.data.list[i].companyCaseStatus == '1') {
          this.solveList.push(res.data.data.list[i])
        }
      }
    }),
    companyNews().then((res) => {
      for (let i = 0; i < res.data.data.list.length; i++) {
        if (this.informationList.length < 4 && res.data.data.list[i].companyNewsStatus == '1') {
          this.informationList.push(res.data.data.list[i])
        }
      }
    }),
    getProductTypeList().then(res => {
      if (res.status == 200) {
        this.productList = res.data.data.map(item => {
          item.remark = 'http://121.40.191.9/uploads/image' + item.remark
          return item
        })
      }
    })
  },
  data () {
    return {
      clientHeight: '480px',
      url: 'http://121.40.191.9' + this.GLOBAL.picURL,
      productList: [
        {
          title: '财务核算',
          contentT: '独立',
          contentB: '有专业范',
          iconPath: require('../assets/img/product1.png'),
          id: 1,
          parall: 'cwhs'
        },
        {
          title: '财务预算',
          contentT: '不止做到，还要做好',
          contentB: '基于财务的运作模式预测',
          iconPath: require('../assets/img/product2.png'),
          id: 2,
          parall: 'cwys'
        },
        {
          title: '财务猎人',
          contentT: '财务人员推荐服务',
          contentB: '为企业猎聘财务人才',
          iconPath: require('../assets/img/product3.png'),
          id: 3,
          parall: 'cwlr'
        },
        {
          title: '税务辅导',
          contentT: '适配高收入人群的',
          contentB: '节税产品',
          iconPath: require('../assets/img/product4.png'),
          id: 4,
          parall: 'swch'
        },
        {
          title: '股权激励',
          contentT: '解决财务烦恼',
          contentB: '专业的事情就让我们来做',
          iconPath: require('../assets/img/product5.png'),
          id: 5,
          parall: 'gqjl'
        },
        {
          title: '年中复盘',
          contentT: '为客户提升财务',
          contentB: '管理效率',
          iconPath: require('../assets/img/product6.png'),
          id: 6,
          parall: 'lzfp'
        },
        {
          title: '年终复盘',
          contentT: '透过历史问题',
          contentB: '解决未来难题',
          iconPath: require('../assets/img/product7.png'),
          id: 7,
          parall: 'nzfp'
        },
        {
          title: '创新财务',
          contentT: '产品持续更新中',
          contentB: '敬请期待',
          iconPath: require('../assets/img/product8.png'),
          id: 8,
          parall: 'cxcw'
        }],
      bannerList: [
        {
          url: require('../assets/img/banner1.jpg'),
          bannerIndex: '1',
          path: '/about/cxjj'
        },
        {
          url: require('../assets/img/banner2.jpg'),
          bannerIndex: '2',
          path: '/product'
        },
        {
          url: require('../assets/img/banner3.jpg'),
          bannerIndex: '3',
          path: '/advisersRecruited'
        }],
      solveList: [],
      informationList: [],
      indexs: 0
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      that.clientHeight = document.body.clientWidth / 4 + 'px'
    }
  },
  methods: {
    jumpProduct (id, parall) {
      // this.$router.push({ path: '/product#' + parall, query: { id: id } });
      this.$router.push(`/product?id=${id}&type=${'a' + parall}`)
    },
    JumpServiceDetail (id) {
      this.$router.push({ path: '/serviceDetail', query: { id: id } })
    },
    toggleShow (i) {
      let slider = document.querySelector('.tab-slider')
      //   let line = document.querySelector('.tab-line');
      //   let a = window.getComputedStyle(line).height;
      let top = 87.98 * i + 'px'
      slider.style.top = top
      this.indexs = i
    },
    Jump (key) {
      this.$router.push({ path: key })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* banner样式 */
    .banner {
        display: block;
        width: 100%;
        height: 100%;
        background-size: cover !important;
    }

    .block a {
        display: block;
        height: 100%;
        width: 100%;
    }

    /* 解决产品 */
    .content {
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
    }

    .content h2 {
        color: #2e324f;
        font-size: 32px;
        text-align: center;
        padding: 3% 0;
    }

    .product .single {
        width: 23%;
        display: inline-block;
        background-color: #fff;
        text-align: center;
        margin-left: 2%;
        margin-top: 2%;
    }

    .single h3 {
        padding: 10% 0;
        color: #2e324f;
        font-size: 24px;
    }

    .single .view {
        display: inline-block;
        width: 50%;
        padding: 4% 0;
        border: 1px solid #2e324f;
        border-radius: 5px;
        font-size: 16px;
        margin: 10% 0 15% 0;
        text-align: center;
        cursor: pointer;
    }

    /* 解决方案 */

    .tabs .tab-t {
        padding: 1% 0;
        width: 100%;
        height: 100%;
        background-color: #2e324f;
        color: #fff;
        font-size: 16px;
    }

    .tabs-container {
        /* height: 500px; */
        /* overflow: hidden; */
        background-color: #fafdff;
        position: relative;
    }

    .tab-slider {
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 87.98px;
        background: #3296fa;
        transition: all .7s;
    }

    .tabs-container .tab-l {
        width: 30%;
        float: left;
        /* height: 500px; */
    }

    .tab-l li {
        /* padding: 10% 8%; */
        height: 87px;
        font-size: 14px;
        color: #2e324f;
        border-bottom: 1px solid #f5f5f5;
    }

    .tab-line p {
        padding: 6% 8%;
    }

    .active {
        background-color: #ffffff;
    }

    .tabs-container .tab-r {
        width: 70%;
        /* height: 500px; */
        float: right;
        cursor: pointer;
    }

    .tab-r a {
        width: 100%;
        /* height: 100%; */
    }

    .tab-r .solveImg {
        width: 100%;
        /* height: 500px; */
    }

    .el-tabs--border-card>.el-tabs__content {
        width: 100%;
    }

    .tabs .jiejue {
        display: block;
        width: 100%;
        height: 100%;
    }

    /* 顾问招揽 */
    .solicit {
        background-color: #fff;
        cursor: pointer;
        text-align: center;
        padding: 0 0 10% 0;
    }

    .solicit p {
        padding: 5% 0;
        color: #2e324f;
        font-size: 16px;
    }

    .solicit div {
        padding: 0 10%;
    }

    .solicit img {
        width: 100%;
        height: 100%;
    }

    /* 小工具 */
    .tool div {
        width: 39%;
        display: inline-block;
        padding: 5% 5%;
        background-color: #fff;
        cursor: pointer;
    }

    /* 企业资讯 */
    .information {
        /* background-color: red; */
        cursor: pointer;
    }

    .info-left {
        width: 46%;
        display: inline-block;
    }

    .info-left img {
        width: 100%;
    }

    .info-right {
        width: 46%;
        display: inline-block;
        padding: 6% 2%;
    }

    .info-right h4 {
        color: #2e324f;
        font-size: 18px;
        padding: 2% 0;
        ;
    }

    .more {
        font-size: 12px;
        float: right;
        color: #2e324f;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue